// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const section = "NetworthSummarySection__section__ie1hP";
export const title = "NetworthSummarySection__title__Vk9mk";
export const body = "NetworthSummarySection__body__JUfV- font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const switchButtonWrapper = "NetworthSummarySection__switchButtonWrapper__Bk5ti";
export const switchButton = "NetworthSummarySection__switchButton__QwcGU";